import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { removeBeat, removeAdditionalLabel, updateContext, updateGhostBeat, updateMouse } from "../pages/Annotator/AnnotatorSlice"
import { ADDITIONAL_LABEL_TYPES } from "../constants/annotator"
import { resolveAnnotationFeatures } from "../utils/annotationFeatures"

const useDeleteBeatShortcut = () => {
	const dispatch = useDispatch()
	const context = useSelector((state) => state.Annotator.context)
	const lastModifiedBeatIndex = useSelector((state) => state.Annotator.lastModifiedBeatIndex)
	const annotations = useSelector((state) => state.Annotator.annotations)
	const { beatAnnotation: beatAnnotationEnabled } = resolveAnnotationFeatures(annotations)

	useEffect(() => {
		if (!beatAnnotationEnabled) return
		const handleKeyDown = (event) => {
			if (event.defaultPrevented || event.repeat || event.isComposing || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return
			if (event.key !== "Delete" && event.key !== "Backspace") return
			const target = event.target
			if (target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="dialog"]')) return

			// Match the label shortcuts: an open marking menu takes precedence
			// over the last selected or modified marking.
			const menuSelected = context.show && context.data.showDelete
			const beatIndex = menuSelected ? context.data.beatIndex : lastModifiedBeatIndex
			if (typeof beatIndex !== "number") return
			const additionalField = menuSelected
				? context.data.additionalField
				: ADDITIONAL_LABEL_TYPES.find(({ field }) => annotations[field]?.some((marker) => marker.i === beatIndex))?.field
			const markers = additionalField ? annotations[additionalField] : annotations.beats
			if (!markers?.some((marker) => marker.i === beatIndex)) return

			event.preventDefault()
			dispatch(additionalField ? removeAdditionalLabel({ field: additionalField, sampleIndex: beatIndex }) : removeBeat(beatIndex))
			dispatch(updateContext({
				show: false,
				data: { top: 0, left: 0, showDelete: false, beatIndex: 0, additionalField: null },
			}))
			dispatch(updateMouse({
				mousedown: false,
				mouseDownOnBeat: false,
				mouseDownOnBeatType: null,
				mouseDownOnAdditionalField: null,
				posX: null,
				posY: null,
				iStart: null,
				bStart: null,
				dragging: null,
			}))
			dispatch(updateGhostBeat({ show: false }))
		}

		window.addEventListener("keydown", handleKeyDown)
		return () => window.removeEventListener("keydown", handleKeyDown)
	}, [annotations, beatAnnotationEnabled, context, lastModifiedBeatIndex, dispatch])
}

export default useDeleteBeatShortcut
